// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import type { GroupedStringParameters } from '../types'
import { StyledAutoSizeTextArea } from './AdditionalParamsTextArea'
import LabeledWrapper from './LabeledWrapper'
import HintWrapper from '../controls/HintWrapper'
import Button from '../controls/PrimaryButton'
import AddParametersGroupBlock from './AddParametersGroupBlock'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 10px;
`

type Props = {|
  includedVkAppsGroups: Array<GroupedStringParameters>,
  errors: Array<string>,
  allowAdding: boolean,
  onChange: Function,
  onIncludedVkAppsGroupAdd: Function,
  onIncludedVkAppsGroupRemove: Function
|}

const t = {
  add: 'Добавить группу',
  vk_apps: 'Приложения ВКонтакте',
  vk_apps_hint:
    'Вы можете показывать рекламу по пользователям, установившим выбранные приложения ВКонтакте. Для выбора приложений укажите их ID'
}

export default class IncludedVkAppsTextArea extends Component<Props> {
  render() {
    return (
      <LabeledWrapper label={this.renderLabelBlock()} errors={this.props.errors} twoLines>
        {_.map(this.props.includedVkAppsGroups, (group, index: number) => {
          return (
            <Wrapper key={index} className={`t-IncludedVkAppsGroup_${index}`}>
              <StyledAutoSizeTextArea
                id={`audience_included_vk_apps_${index}`}
                className="input-item"
                value={group.value}
                maxRows={10}
                onChange={(e) => {
                  const newIncludedVkAppsGroups = _.cloneDeep(this.props.includedVkAppsGroups)
                  newIncludedVkAppsGroups[index].value = e.target.value
                  this.props.onChange(newIncludedVkAppsGroups)
                }}
              />
              {this.props.includedVkAppsGroups.length > 1 && (
                <AddParametersGroupBlock
                  index={index}
                  groups={this.props.includedVkAppsGroups}
                  currentGroup={group}
                  inputName={`audience_vk_apps_group_name_${index}`}
                  inputValue={group.name}
                  onChange={(groups) => this.props.onChange(groups)}
                  onGroupRemove={(groups) => this.props.onIncludedVkAppsGroupRemove(groups)}
                />
              )}
            </Wrapper>
          )
        })}
        {this.props.allowAdding && (
          <Wrapper>
            <Button
              className="t-IncludedVkAppsGroupAddButton"
              small
              onClick={() => {
                this.props.onChange(
                  _.concat(this.props.includedVkAppsGroups, { value: '', name: '' })
                )
                this.props.onIncludedVkAppsGroupAdd()
              }}
            >
              {t.add}
            </Button>
          </Wrapper>
        )}
      </LabeledWrapper>
    )
  }

  renderLabelBlock() {
    return <HintWrapper triggerText={t.vk_apps} popupText={t.vk_apps_hint} alignLeft />
  }
}
